import { ShowcaseItemDto } from '@/api/showcaseItems/showcaseItems.dto';
import { AuctionInfoDto } from '@/features/auction/auctionInfo.dto';
import { DateDto, UserLinkDto } from '@/types';
import UnreachableCaseError from '@/utils/UnreachableCaseError';

export type AuctionCharityItemDto = {
  id: number;
  status: 'created' | 'failed' | 'confirmed' | 'denied';
  showcaseItem: ShowcaseItemDto & {
    auctionInfo: AuctionInfoDto | null;
  };

  /**
   * Only available for status `failed`.
   */
  failureReason?:
    | 'not-for-charity'
    | 'quantity-not-available'
    | 'already-in-other-auction'
    | 'item-owner-not-found'
    | 'no-item-price'
    | 'schedule-auction-failed';
};

export const getFailureReasonDescription = (
  failureReason?:
    | 'not-for-charity'
    | 'quantity-not-available'
    | 'already-in-other-auction'
    | 'item-owner-not-found'
    | 'no-item-price'
    | 'schedule-auction-failed',
) => {
  if (failureReason === 'already-in-other-auction') {
    return 'This item already participates in another Auction.';
  } else if (failureReason === 'not-for-charity') {
    return 'This item was not selected as available for Charity';
  } else if (failureReason === 'quantity-not-available') {
    return 'This item is already sold out.';
  } else if (failureReason === 'item-owner-not-found') {
    return 'Item owner not found.';
  } else if (failureReason === 'no-item-price') {
    return 'Item has no starting price set up.';
  } else if (failureReason === 'schedule-auction-failed') {
    return 'There was some problem with scheduling an individiaul auction.';
  } else throw new UnreachableCaseError(failureReason);
};

export type AuctionCharityDto = {
  id: number;
  user: UserLinkDto;
  items: AuctionCharityItemDto[];

  status: 'created' | 'items-scheduled' | 'cancelled' | 'closed';
  title: string | null;
  description: string | null;
  scheduleItemsAt: DateDto;
  startItemsAt: DateDto;
  endItemsAt: DateDto;
};

export type SubmitAuctionCharityParticipationResponse = {
  failures: Array<{
    auctionCharityItemId: number;
    error:
      | 'not-found'
      | 'not-authorized'
      | 'auction-is-not-in-preparation'
      | 'wrong-item-status'
      | 'item-from-another-auction-charity';
  }>;
};
